import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  CircularProgress,
  Paper,Grid,  IconButton,
} from "@mui/material";
import { useAuth } from "../../../../AuthProvider";
import { ToastContainer, toast } from "react-toastify";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

export default function AssignExamSubjectMarksForm() {


    const baseUrl = process.env.REACT_APP_API_BASE_URL;
     const navigate = useNavigate();
    const { userId, oId, pId, role ,board} = useAuth(); // Access userId from AuthContext
  const [selectedExamType, setSelectedExamType] = useState("");
  const [subjectMarks, setSubjectMarks] = useState({});
  const [overallMarks, setOverallMarks] = useState("");
  const [loading, setLoading] = useState(false);
  const [isManualOverall, setIsManualOverall] = useState(false);
  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSectionOptions, setSscSectionOptions] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState();
const [interSelectedClass, setInterSelectedClass] = useState();
const [selectedCourseType, setSelectedCourseType] = useState("");
const [examTypeOptions, setExamTypeOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);

//classes list api function
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      // Group by class and merge section strings into unique values
      const classSectionMap = {};

      data.forEach(item => {
        const className = item.classRegistration;
        const sectionList = item.sections.split(",").map(s => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sectionList.forEach(section => classSectionMap[className].add(section));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes); // Class dropdown options
    

      // No default selection
      setSscSelectedClass("");
      setSscSectionOptions([]);
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};

useEffect(() => {
    fetchClassRegistrationData();
}, []);




  
     //select subject api 
     const fetchSubjectOptions = async () => {
      try {
        const selectedClass = sscSelectedClass || interSelectedClass;
         if (!selectedClass || !selectedExamType) return;
       
        // For INTERMEDIATE, ensure course type is also selected
        if (board === "INTERMEDIATE" && !selectedCourseType) return;
    
        let response;
    
        if (board === "SSC") {
         
          response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllSubjects/by-class-and-exams/${pId}?classRegistration=${selectedClass}&examTypes=${selectedExamType}`);
        } else if (board === "INTERMEDIATE") {
          response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllSubjectsIntermediate/by-class/${pId}?classRegistration=${selectedClass}&course=${selectedCourseType}`);
        }
    
        if (!response) return;
    
        const data = await response.json();
    
        if (response.ok && Array.isArray(data) && typeof data[0] === 'string') {
          const subjectsArray = data[0].split(',').map((name, index) => ({
            id: index + 1,
            name: name.trim(),
          }));
          setSubjectOptions(subjectsArray);
           setSubjectMarks({}); // reset marks
        } else {
          setSubjectOptions([]);
        }
      } catch (error) {
        console.error("Error fetching subject options:", error);
        setSubjectOptions([]);
      }
    };
    
    
    useEffect(() => {
      if (oId && (sscSelectedClass || selectedExamType ||  interSelectedClass)) {
        fetchSubjectOptions();
      }
    }, [oId, sscSelectedClass,selectedExamType, interSelectedClass,selectedCourseType]); // Add selectedClass dependencies
    
const handleMarksChange = (subject, value) => {
  setSubjectMarks((prev) => {
    const updated = { ...prev, [subject]: value };

    // ✅ If overall marks not manually overridden → auto update sum
    if (!isManualOverall) {
      const total = Object.values(updated).reduce(
        (sum, val) => sum + (parseInt(val, 10) || 0),
        0
      );
      setOverallMarks(total.toString());
    }

    return updated;
  });
};

// Fetch exam types based on selected class & board
const fetchExamTypeOptions = async () => {
  try {
    const selectedClass = sscSelectedClass || interSelectedClass;
    if (!selectedClass) return;

    // For INTERMEDIATE, also require selectedCourseType
    if (board === "INTERMEDIATE" && !selectedCourseType) return;

    let response;

    if (board === "SSC") {
      response = await fetch(
        `${baseUrl}/api/dynamic-classReg/getAllExamsType/by-class/${pId}?classRegistration=${selectedClass}`
        
      );
    } else if (board === "INTERMEDIATE") {
      response = await fetch(
        `${baseUrl}/api/dynamic-classReg/getAllExamsType/by-class/${pId}?classRegistration=${selectedClass}&course=${selectedCourseType}`
      );
    }

    if (!response) return;

    const data = await response.json();

    if (
      response.ok &&
      Array.isArray(data) &&
      typeof data[0] === "string"
    ) {
      const examsArray = data[0]
        .split(",")
        .map((name) => ({
          value: name.trim(),
          // value: name.trim().toUpperCase().replace(/\s+/g, "_"),
          label: name.trim(),
        }));
      setExamTypeOptions(examsArray);
    } else {
      setExamTypeOptions([]);
    }
  } catch (error) {
    console.error("Error fetching exam types:", error);
    setExamTypeOptions([]);
  }
};

useEffect(() => {
  if (oId && (sscSelectedClass || interSelectedClass)) {
    fetchExamTypeOptions();
  }
}, [oId, sscSelectedClass, interSelectedClass, selectedCourseType]);

//submit post functionality
const handleSubmit = async () => {
  if (!sscSelectedClass) {
    toast.error("Please select a class before submitting.");
    return;
  }
  if (!selectedExamType) {
    toast.error("Please select an exam type before submitting.");
    return;
  }
  if (Object.keys(subjectMarks).length === 0) {
    toast.error("Please enter marks for at least one subject.");
    return;
  }

  setLoading(true);
  try {
    // Build query string with required params
    const queryParams = new URLSearchParams({
      romanNumberClass: sscSelectedClass,
      examType: selectedExamType,
      overallMarks: overallMarks || 0, // fallback to 0 if empty
    }).toString();

    const url = `${baseUrl}/api/dynamicMarks/upload/${oId}/${pId}?${queryParams}`;

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({subjectMarks}), // Only the subjectMarks in the body!
    });

    const result = await response.text(); // backend returns plain text

    if (!response.ok) throw new Error(result || "Failed to assign marks");

    // toast.success(result || "Marks assigned successfully!");
    toast.success(result || "Marks assigned successfully!", {
                position: "top-right",
                autoClose: 1000,
              });
     // Wait for 2 seconds before navigating
          setTimeout(() => {
            navigate(-1);
          }, 1080);

  } catch (error) {
    console.error("Error submitting marks:", error);
    toast.error(error.message || "Failed to assign marks.");
  } finally {
    setLoading(false);
  }
};


 return (
  <Box
    component={Paper}
    elevation={4}
    sx={{
      padding: "7px 10px 10px 10px",
      borderRadius: 3,
      margin: "5% 1% 1% 1%",
      bgcolor: "#fff",
    }}
  >
    <Box
  display="flex"
  alignItems="center"
  justifyContent="space-between"  // <-- This spreads left & right content
  sx={{ marginBottom: 3 }}
>
  {/* Left side: Back icon and title */}
  <Box display="flex" alignItems="center">
    <IconButton
      onClick={() => navigate(-1)}
      sx={{ color: "#2e2a54" }}
    >
      <KeyboardBackspaceIcon fontSize="medium" />
    </IconButton>
    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
      Assign Examination Subject Marks
    </Typography>
  </Box>
   {/* Open Dialog Button */}
      <Button variant="contained"
        onClick={() =>
          //  setOpen(true)
          navigate("/SubjectCategoryMarksType")
          } 
         sx={{
                    backgroundColor: "#3C3972",
                    color: "white",
                    //  minWidth: 180,
                    //  height: 45,
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#3C3972",
                    },
                  }}>
        Settings
      </Button>
</Box>


    <Grid container spacing={2} sx={{ marginBottom: 3 }}>
      {/* Class Selector */}
      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <InputLabel id="class-select-label">Select Class</InputLabel>
          <Select
            value={sscSelectedClass}
            label="Select Class"
            onChange={(e) => setSscSelectedClass(e.target.value)}
          >
            {sscClassOptions.length > 0 ? (
              sscClassOptions.map((cls) => (
                <MenuItem key={cls} value={cls}>
                  {cls}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No classes available</MenuItem>
            )}
          </Select>
        </FormControl>
      </Grid>

      {/* Exam Type Selector */}
      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <InputLabel>Select Exam Type</InputLabel>
          <Select
            value={selectedExamType}
            label="Select Exam Type"
            onChange={(e) => setSelectedExamType(e.target.value)}
          >
            {examTypeOptions.length > 0 ? (
              examTypeOptions.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled value="">
                {board === "INTERMEDIATE"
                  ? "No available exam types for selected Year and Course"
                  : "No available exam types for selected Class"}
              </MenuItem>
            )}
          </Select>
        </FormControl>
      </Grid>
    </Grid>

 {subjectOptions.length > 0 && (
  <Grid container spacing={2} sx={{ marginBottom: 3 }}>
    {subjectOptions.map((subject) => (
      <Grid key={subject.id} item xs={12} md={4}>
        <TextField
          fullWidth
          label={subject.name}
          type="text"
          variant="outlined"
          value={subjectMarks[subject.name] || ""}
          // onChange={(e) => handleMarksChange(subject.name, e.target.value)}
         onChange={(e) => {
    const value = e.target.value;
    // Allow only digits or empty string
    if (/^\d*$/.test(value)) {
      handleMarksChange(subject.name, value);
    }
  }}
        />
      </Grid>
    ))}

    <Grid item xs={4}>
      <TextField
  fullWidth
  label={`${selectedExamType} Overall Marks`}
  type="text"
  variant="outlined"
  value={overallMarks}
  onChange={(e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setOverallMarks(value);
      setIsManualOverall(true); // 🚨 mark as manual override
    }
  }}
/>

    </Grid>
  </Grid>
)}


    <Box display="flex" justifyContent="flex-end">
      <Button
        variant="contained"
        color="primary"
         sx={{
                    backgroundColor: "#3C3972",
                    color: "white",
                     minWidth: 180,
                     height: 45,
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#3C3972",
                    },
                  }}
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : "Submit Marks"}
      </Button>
    </Box>



    <ToastContainer position="top-right" autoClose={2000} />
  </Box>
);

}
